"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapShades = void 0;
const mapShades = colors => colors.map(color => ({
  productCode: color.key.toString(),
  hexColors: [color.shadeColor],
  canBeSold: true
}));
exports.mapShades = mapShades;
